import { nullishToOptional } from "../../helpers";
import { DesignElementBase, DesignElementBrandedPart, DesignElementGroupableRequiredPart, DesignElementOrigin, } from "./base";
import { FigmaComponentPropertyMap } from "./component-properties";
import { z } from "zod";
//
// Figma Component
//
export const FigmaComponentOriginPart = z.object({
    nodeId: z.string().optional(),
    width: z.number().optional(),
    height: z.number().optional(),
});
const FigmaComponentAsset = z.object({
    assetId: z.string(),
    assetPath: z.string(),
});
export const FigmaComponentOrigin = DesignElementOrigin.extend(FigmaComponentOriginPart.shape);
export const FigmaComponent = DesignElementBase.extend(DesignElementGroupableRequiredPart.shape)
    .extend(DesignElementBrandedPart.shape)
    .extend({
    origin: FigmaComponentOrigin.optional(),
    thumbnail: FigmaComponentAsset,
    componentPropertyDefinitions: FigmaComponentPropertyMap.optional(),
    variantPropertyValues: z.record(z.string()).optional(),
    svg: FigmaComponentAsset.optional(),
    isAsset: z.boolean(),
    parentComponentPersistentId: nullishToOptional(z.string()),
    renderNodeId: z.string().optional(),
});
//
// Utils
//
export function isImportedFigmaComponent(component) {
    return !!component.origin;
}
